import { unlockDashboard } from "../auth/DashboardLock";
import { useNavigate } from "react-router-dom";
import supabase from "../supabaseClient";
import { useState, useRef, useEffect } from "react";

export default function PinScreen() {
  const navigate = useNavigate();
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");

  const inputRef = useRef(null);

  // Autofocus the PIN input when the screen loads
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  async function checkPin() {
    const { data, error } = await supabase.rpc("check_pin", {
      input_pin: pin,
    });

    if (error || !data) {
      setError("Incorrecte pincode");
      return;
    }

    unlockDashboard();
    navigate("/dashboard");
  }

  function handleKeyDown(e) {
    if (e.key === "Enter") {
      checkPin();
    }
  }

  return (
    <div className="ct-page min-h-screen flex flex-col items-center justify-center p-6">

      {/* Back button */}
      <button
        onClick={() => navigate("/classroom")}
        className="ct-button-secondary mb-6"
      >
        ← Terug naar klasoverzicht
      </button>

      <div className="ct-surface w-full max-w-sm p-8 text-center">
      <p className="ct-eyebrow">Leerkrachtgedeelte</p>
      <h1 className="ct-modal-title mb-4">Pincode invoeren</h1>

      <input
        ref={inputRef}
        type="text"
        name="classroom-pin"
        inputMode="numeric"
        autoComplete="new-password"
        data-1p-ignore="true"
        data-lpignore="true"
        data-bwignore="true"
        data-form-type="other"
        value={pin}
        onChange={(e) => setPin(e.target.value)}
        onKeyDown={handleKeyDown}
        className="ct-form-input ct-pin-input mb-3 text-center text-xl tracking-widest w-40"
      />

      <button
        onClick={checkPin}
        className="ct-button-primary mx-auto"
      >
        Ontgrendel
      </button>

      {error && <p className="text-red-600 mt-3">{error}</p>}
      </div>
    </div>
  );
}
